import { Input } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  && {
    margin-right: 0px;
    padding: 0;
    position: relative;
    border: none;
    .ant-input {
      border: 1px solid ${props => props.theme.palette.border};
      &:hover {
        border: 1px solid ${props => props.theme.palette.icon.purple};
      }
      &:focus {
        box-shadow: 0 0 0 2px ${props => props.theme.palette.text.purple40} !important;
      }
    }
    .ant-input-suffix {
      margin-left: 0px;
    }
    .ant-input-prefix {
      position: absolute;
      z-index: 1;
      top: 10px;
      left: 12px;
    }
    .ant-input-affix-wrapper:focus,
    .ant-input-affix-wrapper-focused {
      box-shadow: none;
    }
    &.ant-input-affix-wrapper .ant-input:not(:last-child) {
      padding-left: 32px;
    }
    &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
      border: none;
    }
    .anticon {
      font-size: 16px;
      color: ${props => props.theme.palette.primary.main};
    }
  }
`;
